import React from 'react';
import EditorControls from './editorControls';

// eslint-disable-next-line
export const getComponentByType = ({ type }, read_only = false) => {
  switch (type) {
    case 'string':
      return EditorControls.StringInput;
    case 'email':
      return EditorControls.StringInput;
    case 'nested object':
    // eslint-disable-next-line
    return read_only ? EditorControls.ItemField : EditorControls.ItemPicker;
    case 'field':
    // eslint-disable-next-line
    return read_only ? EditorControls.ItemField : EditorControls.ItemPicker;
    case 'integer':
      return EditorControls.NumerInput;
    case 'float':
      return EditorControls.NumerInput;
    case 'decimal':
      return EditorControls.NumerInput;
    case 'choice':
      return EditorControls.Selector;
    case 'date':
      return EditorControls.DateInput;
    case 'boolean':
      return EditorControls.CheckboxInput;
    default:
      console.error(`Type ${type} not supported by editor controls`);
      return (function () {
        return <div style={{ color: 'red' }}>{`Type ${type} not supported by editor controls`}</div>;
      });
  }
};

// eslint-disable-next-line
export default getComponentByType;
